const getVSPath = (pathname, withProvider = true) =>
  `/${pathname
    .split('/')
    .slice(1, withProvider ? 5 : 4)
    .join('/')}`;

export default getVSPath;
